export const palette = {
    medical: 'pink',
    problem: 'purple',
    goal: 'blue',
    task: 'green',
    summary: 'teal',
    'medication-purpose': 'yellow',
    'medication-side-effect': 'orange',
    'physician-order-subject': 'red',
    'physician-order-description': 'gray',
};
